<template>
  <div class="profile-detail-block modal-prof-detail profile-card">
    <div>
      <div class="d-flex flex-column">
        <div
          class="d-flex align-items-center justify-content-between"
        >
          <div class="d-flex flex-column">
            <h2 class="margin-bottom-0 name-heading">
              <span
                class="mr-2"
                v-html="highlightText(['last_name'], profile.last_name)"
              ></span>
              <span v-html="highlightText(['full_name'], profile.name)"></span>
              <span class="furigana-text">
                (
                <span
                  v-html="highlightText(['last_furigana'], profile.last_furigana)"
                ></span>
                &nbsp;
                <span
                  v-html="highlightText(['furigana'], profile.furigana)"
                ></span>
                )
              </span>
            </h2>
            <p class="email-text">{{
              profile.email
            }}</p>

          </div>
          <div class="navigation-arrows d-flex" v-if="showNavigation">
            <button
              class="btn btn-arw btn-plain"
              @click="$emit('previous')"
              :disabled="!canGoPrevious"
            >
              <i class="fa fa-chevron-left" aria-hidden="true"></i>
            </button>
            <button
              class="btn btn-arw btn-plain"
              @click="$emit('next')"
              :disabled="!canGoNext"
            >
              <i class="fa fa-chevron-right" aria-hidden="true"></i>
            </button>
          </div>
        </div>
        <div class="d-flex flex-row justify-content-start gap-20">
          <div class="d-flex flex-column info-left">
            <div class="info-row">
              <span class="info-label">生年月日：</span>
              <span class="info-value">{{ profile.birthDate }} ({{ profile.age }}歳)</span>
            </div>
            <div class="info-row">
              <span class="info-label">性別：</span>
              <span class="info-value">{{ profile.gender }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">居住地：</span>
              <span class="info-value">{{ profile.residence.title }}</span>
            </div>
          </div>
          <div class="d-flex flex-column info-right">
            <div class="info-row">
              <span class="info-label">卒業学校：</span>
              <span class="info-value">{{ profile.education.instituteName }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">学部：</span>
              <span class="info-value">{{ profile.education.department }}</span>
            </div>
            <div class="info-row">
              <span class="info-label">卒業年月：</span>
              <span class="info-value">{{ profile.education.graduateYear }}年{{ profile.education.graduateMonth || '' }}月</span>
            </div>
            <div class="info-row">
              <span class="info-label">最終学歴：</span>
              <span class="info-value">{{ profile.education.last.title }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CompanyFrom from '../CompanyFrom.vue';
import EventParticipation from '../EventParticipation.vue';
export default {
  name: 'BasicInfo',
  components: {
    CompanyFrom,
    EventParticipation,
  },
  props: {
    profile: {
      required: true,
    },
    highlights: {
      required: false,
      type: Array,
      default: () => [],
    },
    showNavigation: {
      type: Boolean,
      default: true,
    },
    canGoPrevious: {
      type: Boolean,
      default: true,
    },
    canGoNext: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    companyFrom() {
      return this.profile.companyFrom == '自社HP経由';
    },
  },
  mounted() {
    this.$emit('basicLoaded');
  },
  methods: {
    copyTestingCode() {
      const testingCodeToCopy = document.querySelector('#testing-code');
      testingCodeToCopy.setAttribute('type', 'text');
      testingCodeToCopy.select();

      try {
        const successful = document.execCommand('copy');
        const msg = successful ? 'successful' : 'unsuccessful';
        // eslint-disable-next-line no-alert
      } catch (err) {
        console.log(err);
      }
      /* unselect the range */
      testingCodeToCopy.setAttribute('type', 'hidden');
      window.getSelection().removeAllRanges();
    },
    highlightText(paths, originalText) {
      if (!this.highlights || !this.highlights.length) {
        return originalText;
      }

      const highlights = this.highlights.filter((h) => paths.includes(h.path));
      if (highlights.length === 0) {
        return originalText;
      }

      let highlightedText = originalText;

      for (let highlight of highlights) {
        let reconstructedText = '';
        for (let textPart of highlight.texts) {
          if (textPart.type === 'hit') {
            reconstructedText += `<mark>${textPart.value}</mark>`;
          } else {
            reconstructedText += textPart.value;
          }
        }

        if (
          highlightedText.includes(highlight.texts.map((t) => t.value).join(''))
        ) {
          highlightedText = highlightedText.replace(
            highlight.texts.map((t) => t.value).join(''),
            reconstructedText
          );
        }
      }

      return highlightedText;
    },
  },
};
</script>

<style scoped>

.gap-20 {
  gap: 20px;
}

.profile-card {
  background: white;
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  padding: 24px !important;
  margin-bottom: 16px;
}

.name-heading {
  font-size: 20px !important;
  margin-bottom: 0px !important;
  line-height: 1.2;
  display: flex;
  align-items: baseline;
  gap: 8px;
  color: #000;
  font-weight: bold;
  word-break: break-word;
}

.furigana-text {
  font-size: 14px;
  color: #000;
  font-weight: normal;
}

.email-text {
  word-break: break-all;
  color: #2F80ED;
  font-size: 14px;
  margin: 0px;
}

.navigation-arrows {
  gap: 16px;
}

.navigation-arrows .btn-arw {
  min-width: 40px;
  height: 40px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  background: white;
  color: #3c3c3c;
  display: flex;
  align-items: center;
  justify-content: center;
}

.navigation-arrows .btn-arw:hover:not(:disabled) {
  background: #f5f5f5;
}

.navigation-arrows .btn-arw:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/deep/ mark {
  background-color: yellow;
  padding: 0px;
}
.highlight {
  background-color: yellow;
}
.modal-prof-detail.profile-detail-block {
  padding: 0px !important;
}

.modal-prof-detail .prf-title h1 {
  font-size: 24px;
  word-break: break-word;
}

.modal-prof-detail .prf-title h2 {
  font-size: 16px;
  word-break: break-word;
}

.modal-prof-det.navigation-arrows .btn-arw:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.info-row {
  display: flex;
  font-size: 14px;
  line-height: 1.6;
}

.info-label {
  color: #000000;
  font-weight: bold;
  flex-shrink: 0;
}

.info-value {
  color: #3c3c3c;
}

.info-left {
  width: 250px;
}

/deep/ mark {
  background-color: yellow;
  padding: 0px;
}
.highlight {
  background-color: yellow;
}
.modal-prof-detail.profile-detail-block {
  padding: 15px 0 5px 20px !important;
}

.edit-txt {
  font-size: 13px;
  color: #3c3c3c;
}

.copy-btn {
  font-weight: 100;
  padding: 2px 5px;
  border-radius: 5px !important;
  min-width: 74px !important;
  flex-grow: 0;
  flex-shrink: 0;
  margin-left: auto !important;
  height: 30px !important;
  background: #036d6c;
  border: 1px solid #036d6c;
  opacity: 0.9;
}
/* .company-from {
  position: absolute;
  bottom:0;
} */

</style>
